import {projectKey} from '../config'
import Tool from './Tools'
import Vue from 'vue'

/**
 * Created by Administrator on 2017/3/27.
 */
class Session {
  constructor () {
    this.__init()
  }

  __init () {
    console.log('window.localStorage====', window.localStorage)
  }

  markKey (key) {
    return projectKey + key
  }

  put (key, value) {
    key = this.markKey(key);
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  get (key) {
    key = this.markKey(key);
    return JSON.parse(window.localStorage.getItem(key))
  }

  delete (key) {
    key = this.markKey(key);
    window.localStorage.removeItem(key);
  }

  login (accountToken) {
    return new Promise((resolve, reject) => {
      this.isLogin().then(isLogin => {
        console.log('accountTokenaccountToken', accountToken);
        if (!isLogin) {
          this.put('accountToken', accountToken);
          this.put('isLogin', true);
        }else {
          this.delete('accountToken');
          this.put('accountToken', accountToken);
        }
        resolve(true);
      }).catch(e => {
        reject(e);
      });
    });
  }
  loginLight({token}){
    this.put('lightToken', token);
  }
  setInLight({inLight}){
    this.put('inLight', {inLight});
  }
  getInLight(){
    let inLight = this.get("inLight") || {};
    return inLight.inLight;
  }

  getToken() {
    const _this = this;
    return new Promise((resolve, reject) => {
      const isWexin = navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger"
      if (!isWexin) {
        _this.setInLight({inLight: false});
        resolve(_this.getWechatToken());
      } else {
          const { inLight }= Tool.getRequestParam();
          if(window.__wxjs_environment === 'miniprogram' || _this.getInLight() || inLight === '1'){
            Vue.prototype.global={isMiniProgrm:true};
            _this.setInLight({inLight:true});
            resolve(_this.getLightToken());
          } else {
            _this.setInLight({inLight: false});
            resolve(_this.getWechatToken());
          }
      }
    })
  }

  getWechatToken () {
    return this.getAccountToken().token;
  }
  getLightToken () {
    let lightToken = this.get('lightToken') || '';
    if (!lightToken){
      const { token }= Tool.getRequestParam();
      if(!!token){
        lightToken = token;
        this.loginLight({token});
      }
    }
    return lightToken;
  }


  logout () {
    console.log('退出登录==============');
    this.put('isLogin', false);
    this.delete('userInfo');
    this.delete('openId');
    this.delete('unionId');
    this.delete('accountToken');
    this.delete('lightToken');
    this.delete('phone');
    console.log('退出登录==============');
  }

  getAccessToken () {
    return this.get('accessToken') || ''
  }

  accessToken (token) {
    this.put('accessToken', token)
  }

  getAccountToken () {
    return this.get('accountToken') || ''
  }

  accountToken (token) {
    this.put('accountToken', token)
  }

  getPhone () {
    return this.get('phone') || false
  }

  phone (phone) {
    this.put('phone', phone)
  }

  getUserInfo () {
    return this.get('userInfo') || {}
  }

  isLogin () {
    return new Promise((resolve, reject) => {
      if(this.get('isLogin')){
        resolve(true);
      } else {
        this.getToken().then(token => {
          this.put('isLogin', !!token);
          resolve(!!token);
        }).catch((e)=>{
          console.log('isLogin====',e);
          resolve(false)
        });
      }
    });
  }

  smsToken(smsToken){
    this.put('smsToken',smsToken)
  }
  getSmsToken(){
    return this.get('smsToken')
  }

  openId (openId){
    this.put('openId',openId)
  }
  getOpenId(){
    return this.get('openId') || false
  }
  unionId (unionId){
    this.put('unionId',unionId)
  }
  getUnionId(){
    return this.get('unionId')
  }

  nickname(nickname) {
    this.put('nickname', nickname)
  }

  getNickname() {
    return this.get('nickname')
  }

  userId(userId) {
    this.put('userId', userId)
  }

  getUserId() {
    return this.get('userId')
  }

  backUrl(backUrl) {
    this.put('backUrl', backUrl)
  }

  getBackUrl() {
    return this.get('backUrl')
  }

  easeToken(easeToken) {
    this.put('easeToken', easeToken)
  }

  getEaseToken() {
    return this.get('easeToken')
  }

  easeMap(easeMap) {
    this.put('easeMap', easeMap)
  }

  getEaseMap() {
    return this.get('easeMap')
  }

  avatar(avatar) {
    this.put('avatar', avatar)
  }

  getAvatar() {
    return this.get('avatar')
  }

  userType(userType){
    this.put('userType', userType)
  }

  getUserType() {
    return this.get('userType')
  }

  clientUserInfo(clientUserInfo){
    this.put('clientUserInfo', clientUserInfo)
  }

  getClientUserInfo() {
    return this.get('clientUserInfo')
  }

  getBaseImageUrl () {
    return "http://img.shuimujiaju.com/";
  }

  setVerifier (verifier = {}) {
    return this.put('dealer-verifier', verifier)
  }
  getVerifier() {
    return this.get('dealer-verifier')
  }
  verifierIsLogin() {
    return this.getVerifier() && this.getVerifier().id
  }
}
export default new Session()
